<!-- Manage Boards Container -->
<div class="manage-boards-container">

  <!-- View Mode: List of boards -->
  <ng-container *ngIf="mode === manageBoardMode.view">
    <!-- Header with Create Button -->
    <div class="header">
      <button mat-raised-button color="primary" (click)="startCreating()">
        <mat-icon>add</mat-icon>
        Create New Board
      </button>
    </div>

    <!-- Board List -->
    <mat-list class="board-list">
      <!-- Header Row -->
      <mat-list-item class="board-header">
        <div class="board-name">Board Name</div>
        <div class="board-name">Description</div>
        <div class="board-name">Type</div>
        <div class="board-name">Created By</div>
        <div class="board-name">Created Date</div>
        <div class="board-name">Modified By</div>
        <div class="board-name">Modified Date</div>
        <div class="board-name">Default</div>
        <div class="board-name">Shared</div>
        <div class="board-name">Actions</div>
      </mat-list-item>

      <!-- Board Items -->
      <mat-list-item *ngFor="let board of boards" class="board-item">
        <div class="board-name">{{ board.userBoardName }}</div>
        <div class="board-name">{{ board.userBoardDescription }}</div>
        <div class="board-name">
          <mat-chip>{{ getBoardTypeLabel(board.boardType) }}</mat-chip>
        </div>
        <div class="board-name">{{ board.createdBy }}</div>
        <div class="board-name">{{ board.createdDate }}</div>
        <div class="board-name">{{ board.modifiedBy }}</div>
        <div class="board-name">{{ board.modifiedDate }}</div>
        <div class="board-name">
          <mat-icon *ngIf="board.isDefault" color="primary">check_circle</mat-icon>
        </div>
        <div class="board-name">
          <mat-icon *ngIf="board.isShared" color="accent">share</mat-icon>
        </div>
        <div class="board-name board-actions">
          <button
            mat-icon-button
            color="primary"
            (click)="editBoard(board)"
            matTooltip="Edit Board">
            <mat-icon>edit</mat-icon>
          </button>
          <button
            mat-icon-button
            color="warn"
            (click)="deleteBoard(board)"
            matTooltip="Delete Board">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-list-item>
    </mat-list>
  </ng-container>

  <!-- Board Type Selection Mode -->
  <ng-container *ngIf="mode === manageBoardMode.selectType">
    <bhub-board-type-selector
      (boardTypeSelected)="onBoardTypeSelected($event)"
      (cancelSelection)="onBoardTypeSelectionCancelled()">
    </bhub-board-type-selector>
  </ng-container>

  <!-- Create/Edit Mode -->
  <ng-container *ngIf="mode === manageBoardMode.create || mode === manageBoardMode.edit">
    <!-- Tile Board Editor -->
    <bhub-tile-board-editor
      *ngIf="selectedBoardType === boardTypes.TileBoard"
      [board]="editingBoard"
      [mode]="mode === manageBoardMode.create ? 'create' : 'edit'"
      (saveBoard)="onSaveBoard($event)"
      (cancelEdit)="onCancelEdit()">
    </bhub-tile-board-editor>

    <!-- Spreadsheet Board Editor -->
    <bhub-spreadsheet-board-editor
      *ngIf="selectedBoardType === boardTypes.SpreadsheetBoard"
      [board]="editingBoard"
      [mode]="mode === manageBoardMode.create ? 'create' : 'edit'"
      (saveBoard)="onSaveBoard($event)"
      (cancelEdit)="onCancelEdit()">
    </bhub-spreadsheet-board-editor>
  </ng-container>

</div>